module.exports = __webpack_public_path__ + "static/img/natwest-logo.7817155.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/natwest-logo.jpg
// module id = 588
// module chunks = 0